import {
  SUBSCRIPTION_BUSINESS,
  SUBSCRIPTION_TRIAL,
  SUBSCRIPTION_CREATOR,
  SUBSCRIPTION_ENTERPRISE,
  SUBSCRIPTION_CREATOR_ANNUAL,
  SUBSCRIPTION_BUSINESS_ANNUAL,
} from '../../../pages/Subscription/config';

export const CLASSROOM_NOT_GRADABLE = 0;
export const CLASSROOM_GRADABLE = 1;
export const SCHOOL_NOT_GRADABLE = 2;
export const SCHOOL_GRADABLE = 3;

export interface OrganizationSubscription {
  organizationSubscriptionStatus: number;
  currentPeriodEndDate: string;
  trialStart?: string;
  trialEnd?: string;
  last4?: string;
  qty: number;
  type: number;
  cancelAtPeriodEnd: boolean;
  stripeSubscriptionId?: string;
  canceledAt?: string;
  endedAt?: string;
}

export const getSubscriptionNameFromTier = (tier: number) => {
  switch (tier) {
    case SUBSCRIPTION_TRIAL:
      return 'Trial';
    case SUBSCRIPTION_CREATOR:
    case SUBSCRIPTION_CREATOR_ANNUAL:
      return 'Creator';
    case SUBSCRIPTION_BUSINESS:
    case SUBSCRIPTION_BUSINESS_ANNUAL:
      return 'Business';
    case SUBSCRIPTION_ENTERPRISE:
      return 'Enterprise';
  }
};

export const SUBSCRIPTION_STATUS_ACTIVE = 0;
export const SUBSCRIPTION_STATUS_CANCELLED = 1;
export const SUBSCRIPTION_STATUS_ENDED = 2;
